import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import requiredIf from 'react-required-if';
import DownloadInstructions from './DownloadInstructions';
import styles from './styles.module.styl';

const getResourcesList = resources =>
  resources.reduce((acc, current, index, arr) => (
    <Fragment>
      {acc}
      {index === arr.length - 1 ? ' and ' : ', '}
      {current}
    </Fragment>
  ));


const DownloadSampleModal = ({
  show,
  handleHide,
  showClient,
  showApi,
  selectedAppName,
  selectedApi,
  downloadInstructions,
  downloadInProgress,
  downloadSample,
  githubSampleLink,
  trackViewGithubSample,
  isFramedMode
}) => {
  const sampleConfiguredResources = getResourcesList(
    [
      showClient &&
        <span className={styles.resourceItem}>
          the application <code>{selectedAppName}</code>
        </span>,
      showApi && selectedApi &&
        <span className={styles.resourceItem}>the API <code>{selectedApi.name}</code></span>
    ].filter(resource => !!resource)
  );

  return (
    <Modal
      bsClass="modal"
      show={show}
      onHide={handleHide}
    >
      <Modal.Header
        bsClass="modal-header has-border"
        closeButton
      >
        <Modal.Title>Download sample</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className={styles.description}>
          You are downloading a working sample configured for {sampleConfiguredResources}
        </p>
        <DownloadInstructions
          content={downloadInstructions}
          isFramedMode={isFramedMode}
        />
      </Modal.Body>
      <Modal.Footer>
        <a
          href={githubSampleLink}
          onClick={trackViewGithubSample}
          target="_blank"
          rel="noreferrer noopener"
          className="btn btn-transparent"
        >
          View on Github
        </a>
        <button
          disabled={downloadInProgress}
          onClick={() => downloadSample()}
          className="btn btn-success"
        >
          {downloadInProgress ? 'Downloading...' : 'Download'}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

DownloadSampleModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleHide: PropTypes.func.isRequired,
  showClient: PropTypes.bool.isRequired,
  showApi: PropTypes.bool.isRequired,
  selectedAppName: requiredIf(PropTypes.string, props => props.showClient),
  selectedApi: requiredIf(PropTypes.object, props => props.showApi),
  downloadInstructions: PropTypes.string.isRequired,
  downloadInProgress: PropTypes.bool.isRequired,
  downloadSample: PropTypes.func.isRequired,
  githubSampleLink: PropTypes.string.isRequired,
  trackViewGithubSample: PropTypes.func.isRequired,
  isFramedMode: PropTypes.bool.isRequired
};

export default DownloadSampleModal;
